import React, { useState }from 'react';
import InlineSVG from 'svg-inline-react';
import { useHistory, Link } from 'react-router-dom';
import { getUserObject } from '../../services/auth';
import ProfilePicture from '../../components/ProfilePicture';
import { logout } from '../../services/auth';
import { scroller } from 'react-scroll';


const chevronDown = `<svg id="ICON_1" data-name="ICON 1" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
<path id="_" data-name="&gt;" d="M7,6.651l-.469-.542L1.248,0,0,1.083,4.813,6.651,0,12.218,1.248,13.3,6.531,7.192Z" transform="translate(19 9) rotate(90)" fill="#ffffff"/>
</svg>
`;

const svgLogo = '<svg viewBox="0 0 257.028 23" xmlns="http://www.w3.org/2000/svg"><path d="m255.7 298.764a11.013 11.013 0 0 1 -4.32-4.1 11.945 11.945 0 0 1 0-11.849 11.025 11.025 0 0 1 4.32-4.1 13.783 13.783 0 0 1 11.4-.46 10.467 10.467 0 0 1 3.923 2.922l-3.3 3.05a7.1 7.1 0 0 0 -5.591-2.606 7.427 7.427 0 0 0 -3.685.906 6.439 6.439 0 0 0 -2.525 2.525 7.951 7.951 0 0 0 0 7.371 6.433 6.433 0 0 0 2.525 2.525 7.418 7.418 0 0 0 3.685.906 7.067 7.067 0 0 0 5.591-2.637l3.3 3.05a10.293 10.293 0 0 1 -3.939 2.955 13.087 13.087 0 0 1 -5.241 1.016 12.764 12.764 0 0 1 -6.143-1.474z" fill="#ffa900" transform="translate(-249.803 -277.241)"/><path d="m286.05 298.748a11.068 11.068 0 0 1 -4.352-4.114 11.827 11.827 0 0 1 0-11.786 11.089 11.089 0 0 1 4.352-4.114 13.762 13.762 0 0 1 12.468 0 11.342 11.342 0 0 1 0 20.014 13.761 13.761 0 0 1 -12.468 0zm9.8-3.8a6.5 6.5 0 0 0 2.494-2.525 7.952 7.952 0 0 0 0-7.371 6.511 6.511 0 0 0 -2.494-2.525 7.442 7.442 0 0 0 -7.116 0 6.507 6.507 0 0 0 -2.494 2.525 7.958 7.958 0 0 0 0 7.371 6.5 6.5 0 0 0 2.494 2.525 7.441 7.441 0 0 0 7.116 0z" fill="#ffa900" transform="translate(-257.317 -277.241)"/><path d="m338.022 277.748v22.238h-4.222l-11.087-13.5v13.5h-5.083v-22.238h4.257l11.055 13.5v-13.5z" fill="#ffa900" transform="translate(-266.61 -277.367)"/><path d="m355.531 281.942h-7.116v-4.194h19.378v4.194h-7.116v18.044h-5.146z" fill="#ffa900" transform="translate(-274.239 -277.367)"/><path d="m390.056 295.221h-10.325l-1.969 4.765h-5.274l9.912-22.238h5.083l9.943 22.238h-5.4zm-1.62-3.908-3.526-8.514-3.526 8.514z" fill="#ffa900" transform="translate(-280.205 -277.367)"/><g fill="#fff"><path d="m412.336 298.764a11.014 11.014 0 0 1 -4.32-4.1 11.946 11.946 0 0 1 0-11.849 11.025 11.025 0 0 1 4.32-4.1 13.783 13.783 0 0 1 11.4-.46 10.467 10.467 0 0 1 3.923 2.922l-3.3 3.05a7.1 7.1 0 0 0 -5.591-2.606 7.428 7.428 0 0 0 -3.685.906 6.439 6.439 0 0 0 -2.525 2.525 7.952 7.952 0 0 0 0 7.371 6.433 6.433 0 0 0 2.525 2.525 7.42 7.42 0 0 0 3.685.906 7.068 7.068 0 0 0 5.591-2.637l3.3 3.05a10.3 10.3 0 0 1 -3.938 2.955 13.091 13.091 0 0 1 -5.242 1.016 12.764 12.764 0 0 1 -6.143-1.474z" transform="translate(-288.619 -277.241)"/><path d="m442.69 298.748a11.071 11.071 0 0 1 -4.353-4.114 11.837 11.837 0 0 1 0-11.786 11.092 11.092 0 0 1 4.353-4.114 13.762 13.762 0 0 1 12.469 0 11.342 11.342 0 0 1 0 20.014 13.761 13.761 0 0 1 -12.469 0zm9.8-3.8a6.488 6.488 0 0 0 2.494-2.525 7.952 7.952 0 0 0 0-7.371 6.494 6.494 0 0 0 -2.494-2.525 7.441 7.441 0 0 0 -7.116 0 6.493 6.493 0 0 0 -2.493 2.525 7.945 7.945 0 0 0 0 7.371 6.487 6.487 0 0 0 2.493 2.525 7.441 7.441 0 0 0 7.116 0z" transform="translate(-296.133 -277.241)"/><path d="m494.5 299.986-.032-13.343-6.544 10.993h-2.319l-6.505-10.707v13.057h-4.828v-22.238h4.257l8.323 13.819 8.2-13.819h4.225l.064 22.238z" transform="translate(-305.426 -277.367)"/><path d="m514.6 277.748h5.146v22.238h-5.146z" transform="translate(-315.42 -277.367)"/><path d="m543.017 288.392h4.7v9.023a13.439 13.439 0 0 1 -4.193 2.1 16.3 16.3 0 0 1 -4.8.73 13 13 0 0 1 -6.228-1.477 10.991 10.991 0 0 1 -4.336-4.1 11.949 11.949 0 0 1 0-11.849 10.945 10.945 0 0 1 4.368-4.1 13.253 13.253 0 0 1 6.29-1.477 13.766 13.766 0 0 1 5.305.985 10.513 10.513 0 0 1 4 2.859l-3.3 3.049a7.642 7.642 0 0 0 -5.75-2.51 7.851 7.851 0 0 0 -3.78.89 6.387 6.387 0 0 0 -2.573 2.509 7.9 7.9 0 0 0 0 7.4 6.515 6.515 0 0 0 2.557 2.525 7.575 7.575 0 0 0 3.732.906 8.347 8.347 0 0 0 4-.952z" transform="translate(-318.392 -277.241)"/><path d="m565.079 298.748a11.069 11.069 0 0 1 -4.352-4.114 11.832 11.832 0 0 1 0-11.786 11.09 11.09 0 0 1 4.352-4.114 13.762 13.762 0 0 1 12.468 0 11.341 11.341 0 0 1 0 20.014 13.761 13.761 0 0 1 -12.468 0zm9.8-3.8a6.493 6.493 0 0 0 2.493-2.525 7.952 7.952 0 0 0 0-7.371 6.5 6.5 0 0 0 -2.493-2.525 7.442 7.442 0 0 0 -7.116 0 6.5 6.5 0 0 0 -2.494 2.525 7.952 7.952 0 0 0 0 7.371 6.49 6.49 0 0 0 2.494 2.525 7.441 7.441 0 0 0 7.116 0z" transform="translate(-326.461 -277.241)"/><path d="m405.839 299.8-23.766-.054 1.647-3.985 22.168-.008z" transform="translate(-282.58 -281.829)"/></g></svg>';

const Menu = ({ theme }) => {
  const history = useHistory();

  const authUser = getUserObject();
  let profile;

  const logUserOut = () => {
    logout();
    history.push('/');
  };

  const [isOpenMenu, setOpenMenu] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  if(authUser) {
    profile = 
      <div className="menu -profile-logged" key={authUser.userId}>
        <div className="menu -profile-link" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          <picture>
            <ProfilePicture path={authUser.profilePicture} title={authUser.userName} />
          </picture>
          <InlineSVG src={chevronDown} />
        </div>
        <div className={`menu -profile -dropdown ${isDropdownOpen ? '-open' : ''}`}>
        <Link to="/meu-perfil">
          Meu perfil
        </Link>
        <Link to="#" onClick={() => logUserOut()}>
          Sair
        </Link>
        </div>
      </div>
    ;
  }
  function handleToggleMenu(e) {
    e.preventDefault();
    if(isOpenMenu === false) {
      document.body.style.overflow = 'hidden';
      setOpenMenu(true);
    } else {
      document.body.style.overflow = 'auto';
      setOpenMenu(false);
    }
  }

  const handleResetBody= () => {
    document.body.style.overflow = 'auto';
  }

  const handleScrollTo = (e) => {
    document.body.style.overflow = 'auto';
    e.preventDefault();

    scroller.scrollTo('quem-somos', {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: 0
    });
  }
  return (
    <nav className={`menu -bar -${theme}`}>
      <div className="container">
        <div className="menu -cnt">
          <div className="menu -logo">
            <Link to="/" onClick={handleResetBody}>
              <InlineSVG src={svgLogo} />
              <span className="sr-only">ContaComigo</span>
            </Link>
          </div>
          <div className={`menu -links ${isOpenMenu ? '-isOpen' : ''}`}>
            <Link to="/buscar" className="menu -link" onClick={handleResetBody}>
              <span>Produtos e Serviços</span>
            </Link>
            {!authUser &&
              <Link to="/cadastro" className="menu -link" onClick={handleResetBody}>
                <span>Quero fazer parte</span>
              </Link>
            }
            <Link to="/" className="menu -link" onClick={handleScrollTo}>
              <span>Quem Somos</span>
            </Link>
            <Link to="/contato" className="menu -link" onClick={handleResetBody}>
              <span>Fala comigo</span>
            </Link>
          </div>
          <div className={`menu -profile ${isOpenMenu ? '-isOpen' : ''}`}>
            {profile ? 
              profile : 
              <div className="menu -profile-login">
                <Link to="/login" onClick={handleResetBody}>
                  <i className="icon"></i>
                  <span>Bem vindo <b>:)</b><br />Acesse sua conta</span>
                </Link>
              </div>
            }
          </div>
          <div className={`menu -open ${isOpenMenu ? '-isOpen' : ''}`}>
            <button
              className="menu -open-link"
              onClick={handleToggleMenu}
            >
              <span className="sr-only">Abrir menu</span>
              <span className="menu -open-bar"></span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Menu;